import React from 'react';
import PropTypes from 'prop-types'
import './QueuePage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate'
import NotesHeaderSortLink from './NotesHeaderSortLink';
    
const NotesTableSortHeader = ({ queue, sort, onSortChanged, isReversed, renderLink }) => {   

    const handleSort = (sortValue, reversed) => {
        onSortChanged(sortValue, reversed)
    }

    return (
        <div id='notes-table' className="agent-sort columns">
            <div className='column is-6 ml-6 has-text-weight-medium'>
                <HrbTranslate text='Notes.Header.Notes' />
            </div>
            <div className='column is-4'>                
                <NotesHeaderSortLink renderLink={renderLink} sortKey={sort} currentSortKey={sort} sortValue={'date'} reversed={isReversed} onSortChanged={handleSort} onClick={handleSort}>
                    <HrbTranslate text='Notes.Header.Dates' />
                </NotesHeaderSortLink>
            </div>
        </div>
    );
}

NotesTableSortHeader.propTypes = {
    queue: PropTypes.object,
    onSortChanged: PropTypes.func.isRequired
}

export default NotesTableSortHeader